/**
 * Các loại PlanTemp
 */
export default {
  ReceiptTT_343_344: 1,
  ReceiptTT_342: 51,
  ExpenseTT_343_344: 2,
  ExpenseTT_342: 52,
};
